import styled from "styled-components";

//TODO: Check styles after merging all PRs
export const Root = styled.div`
  z-index: 1;
  position: relative;
  gap: ${({ theme }) => theme.spacing.spacing_24};
  padding-top: ${({ theme }) => theme.spacing.spacing_64};
  padding-bottom: ${({ theme }) => theme.spacing.spacing_64};

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    padding-top: ${({ theme }) => theme.spacing.spacing_32};
    padding-bottom: ${({ theme }) => theme.spacing.spacing_96};
  }

  ${({ theme }) => theme.breakpointsV2.desktop} {
    padding-top: ${({ theme }) => theme.spacing.spacing_32};
    padding-bottom: ${({ theme }) => theme.spacing.spacing_128};
  }

  ${({ theme }) => theme.breakpointsV2.desktop} {
    padding-top: ${({ theme }) => theme.spacing.spacing_160};
  }
`;
